import React, { Component } from 'react';
import ReceberPage from './receber.page';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as actions from '../../material.action';
import * as commonActions from '../../../../../../app/common/common.action';
import { acessoPermitido } from '../../../../../../acessos.seguranca';
import CommonFunctions from '../../../../../../app/common/util/functions.common';
import WebapiCommon from '../../../../../../app/common/util/webapi.common';

import IntlMessage from '../../../../../../helpers/intlMessage';

class ReceberContainer extends Component {
  constructor() {
    super();
    this.quantidadeRef = React.createRef();
    this.topografiaRef = React.createRef();
    this.medicoMicroscopistaRef = React.createRef();
    this.state = {
      modalTopografia: false,
      idFrascoSelecionado: undefined,
      idNovaTopografiaSelecionada: undefined,
      labelNovaTopografiaSelecionada: undefined,
      labelTopografiaAtual: undefined,
      modalCancelFrasco: false,
      justificativaCancelamentoFrasco: undefined,
      isUltimoFrasco: false,
      showModalCadastroTopografia: false,
      topografiaASerCadastrada: undefined,
      cancelarBlocoAndLaminas: false,
      existeBlocoAndLamina: false,
      blocosExistentes: [],
      laminasExistentes: [],
    };
  }

  componentDidMount() {
    if (this.topografiaRef && this.topografiaRef.current !== null) this.topografiaRef.current.focus();
  }

  render() {
    const { topografiaselecionada, medicoMicroscopistaSelecionado, quantidadeFrascos } = this.props;
    const {
      existeBlocoAndLamina,
      blocosExistentes,
      laminasExistentes,
      cancelarBlocoAndLaminas,
    } = this.state;

    let labelChekboxCancelarBlocoAndLaminas = 'Existem';
    labelChekboxCancelarBlocoAndLaminas +=
      blocosExistentes.length > 0 ? ' blocos' : '';
    labelChekboxCancelarBlocoAndLaminas +=
      laminasExistentes.length > 0
        ? blocosExistentes.length > 0
          ? ' e lâminas'
          : ' lâminas'
        : '';

    labelChekboxCancelarBlocoAndLaminas +=
      ' cadastrados para esse exame. Deseja cancelar assim mesmo?';

    return (
      <ReceberPage
        usuario={this.props.usuario}
        existeBlocoAndLamina={existeBlocoAndLamina}
        blocosExistentes={blocosExistentes}
        laminasExistentes={laminasExistentes}
        labelChekboxCancelarBlocoAndLaminas={labelChekboxCancelarBlocoAndLaminas}
        cancelarBlocoAndLaminas={cancelarBlocoAndLaminas}
        quantidadeRef={this.quantidadeRef}
        topografiaRef={this.topografiaRef}
        medicoMicroscopistaRef={this.medicoMicroscopistaRef}
        options={this.props.topografias}
        optionsMedicos={this.props.medicos}
        frascosGravados={this.props.frascosGravados}
        frascosNovos={this.props.frascosNovos}
        frascoExterno={this.props.detalhes.frascoExterno}
        nrExameExterno={this.props.detalhes.nrExameExterno}
        recebimentoFinalizado={this.props.recebimentoFinalizado}
        quantidade={quantidadeFrascos}
        onSelectTopografia={this.onSelectTopografia.bind(this)}
        onSelectMedicoMicroscopista={this.onSelectMedicoMicroscopista.bind(this)}
        onSelectQuantidadeAdicionaFrasco={this.onSelectQuantidadeAdicionaFrasco.bind(this)}
        onChangeQuantidade={this.onChangeQuantidade.bind(this)}
        onClickRemoveFrasco={this.onClickRemoveFrasco.bind(this)}
        acessoPermitido={acessoPermitido}
        altura={this.props.altura}
        modalTopografia={this.state.modalTopografia}
        toggleModalTopografia={this.toggleModalTopografia.bind(this)}
        selecionarNovaTopografia={this.selecionarNovaTopografia.bind(this)}
        atualizarTopografia={this.atualizarTopografia.bind(this)}
        cancelarFrasco={this.cancelarFrasco.bind(this)}
        modalCancelFrasco={this.state.modalCancelFrasco}
        toggleModalCancelFrasco={this.toggleModalCancelFrasco.bind(this)}
        justificativaCancelamentoFrasco={this.state.justificativaCancelamentoFrasco}
        onChangeJustificativaCancelamentoFrasco={this.onChangeJustificativaCancelamentoFrasco.bind(this)}
        isUltimoFrasco={this.state.isUltimoFrasco}
        exameFinalizado={this.props.exameFinalizado}
        handleCreateSelectCreatable={this.handleCreateSelectCreatable.bind(this)}
        showModalCadastroTopografia={this.state.showModalCadastroTopografia}
        toggleModalCadastroTopografia={this.toggleModalCadastroTopografia.bind(this)}
        topografiaASerCadastrada={this.state.topografiaASerCadastrada}
        atualizarTopografias={this.atualizarTopografias.bind(this)}
        topografiaselecionada={topografiaselecionada}
        medicoMicroscopistaSelecionado={medicoMicroscopistaSelecionado}
        microAplicavel={this.props.microAplicavel}
        selecionarTopografiaRecemCadastrada={this.selecionarTopografiaRecemCadastrada.bind(this)}
        onChangeCheckboxCancelarBlocosAndLaminas={this.onChangeCheckboxCancelarBlocosAndLaminas.bind(this)}
      />
    );
  }

  onChangeCheckboxCancelarBlocosAndLaminas() {
    this.setState((state) => ({
      cancelarBlocoAndLaminas: !state.cancelarBlocoAndLaminas,
    }));
  }

  onSelectTopografia(event) {
    if (event !== null) {
      this.props.actions.alterarTopografiaSelecionada({
        value: event.value,
        label: event.label,
      });

      if (this.quantidadeRef.current !== null){
        this.quantidadeRef.current.focus();
      }
    }else{
      this.props.actions.alterarTopografiaSelecionada();
    }
  }

  onSelectMedicoMicroscopista(event) {
    if (event !== null) {
      this.props.actions.alterarMedicoMicroscopistaSelecionado({
        value: event.value,
        label: event.label,
      });

      if (this.quantidadeRef.current !== null){
        this.quantidadeRef.current.focus();
      }
    } else {
      this.props.actions.alterarMedicoMicroscopistaSelecionado();
    }
  }

  onChangeQuantidade(event) {
    this.props.actions.alterarQuantidadeFrascos(event.target.value);
  }

  onSelectQuantidadeAdicionaFrasco() {
    let { topografiaselecionada, medicoMicroscopistaSelecionado, quantidadeFrascos } = this.props;

    if (parseInt(quantidadeFrascos, 10) === 0) {
      return;
    }

    if (!topografiaselecionada) {
      this.props.commonActions.showAlerta('alerta', 'Nenhuma topografia foi informada', 1500);
      return;
    }

    if (this.props.recebimentoFinalizado) {
      this.props.commonActions.showAlerta('alerta', 'Recebimento material realizado', 1500);
      return;
    }

    this.props.commonActions.showFadeCarregando(true);

    let frascosNovosJaGerados = [...this.props.frascosNovos];

    for (let i = 0; i < quantidadeFrascos; i++) {
      frascosNovosJaGerados.push({
        idTopografia: topografiaselecionada.value,
        idMedicoMicroscopista: medicoMicroscopistaSelecionado ? medicoMicroscopistaSelecionado.value : null,
        quantidade: 1,
      });
    }

    let frascosNovos = [];
    frascosNovosJaGerados.forEach((frasco) => {
      frascosNovos.push({
        topografiaId: frasco.idTopografia,
        medicoMicroscopistaId: frasco.idMedicoMicroscopista,
        quantidade: 1,
      });
    });

    WebapiCommon.gerarFrasco(this.props.detalhes.laudo, frascosNovos).then(
      (frascos) => {
        this.props.commonActions.adicionarNovoFrasco(frascos.data);
        this.props.actions.alterarQuantidadeFrascos(0);
        this.props.actions.alterarTopografiaSelecionada(null);
        this.topografiaRef.current.focus();
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta('sucesso', <IntlMessage id = "dashboards.examDetail.addBottles"/>, 1500);
      }
    );
  }

  onClickRemoveFrasco(dsFrasco) {
    if (this.props.recebimentoFinalizado) {
      alert(<IntlMessage id = "dashboards.examDetail.materialReceipt"/>);
      return;
    }

    this.props.commonActions.showFadeCarregando(true);

    let frascos = [...this.props.frascosNovos];
    let index = frascos.findIndex((t) => t.dsFrasco === dsFrasco);

    if (index === -1) return;

    frascos.splice(index, 1);

    for (let i = 0; i < frascos.length; i++) {
      frascos[i].ordem = i + 1;
    }

    let frascosNovos = [];

    frascos.forEach((frasco) => {
      frascosNovos.push({
        topografiaId: frasco.idTopografia,
        quantidade: 1,
      });
    });

    WebapiCommon.gerarFrasco(this.props.detalhes.laudo, frascosNovos).then(
      (frascosAtualizados) => {
        this.props.commonActions.adicionarNovoFrasco(frascosAtualizados.data);
        this.props.actions.alterarQuantidadeFrascos(0);
        this.topografiaRef.current.focus();
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta('sucesso', <IntlMessage id = "dashboards.examDetail.removedBottle"/>, 1500);
      }
    );
  }

  toggleModalTopografia(idFrascoSelecionado, labelTopografiaAtual) {
    this.setState((state) => ({
      modalTopografia: !state.modalTopografia,
      idFrascoSelecionado: idFrascoSelecionado,
      labelTopografiaAtual: labelTopografiaAtual,
    }));
  }

  toggleModalCancelFrasco(idFrascoSelecionado) {
    this.setState((state) => ({
      modalCancelFrasco: !state.modalCancelFrasco,
      idFrascoSelecionado: idFrascoSelecionado,
      justificativaCancelamentoFrasco: undefined,
      isUltimoFrasco:
        this.props.frascosGravados.filter((el) => el.status !== 'CANCELADO')
          .length === 1,
    }));
  }

  selecionarNovaTopografia(
    idNovaTopografiaSelecionada,
    labelNovaTopografiaSelecionada
  ) {
    let labelNovaTopografiaSemCodigo = this.removerCodigoLabelTopografia(
      labelNovaTopografiaSelecionada
    );
    this.setState({
      idNovaTopografiaSelecionada: idNovaTopografiaSelecionada,
      labelNovaTopografiaSelecionada: labelNovaTopografiaSemCodigo,
    });
  }

  removerCodigoLabelTopografia(labelNovaTopografiaSelecionada) {
    let index = labelNovaTopografiaSelecionada.indexOf('-');
    let length = labelNovaTopografiaSelecionada.length;
    let labelNovaTopografiaSemCodigo = labelNovaTopografiaSelecionada
      .slice(index + 1, length)
      .trimStart();

    return labelNovaTopografiaSemCodigo;
  }

  atualizarTopografia() {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.atualizarTopografia(
      this.props.detalhes.laudo,
      this.state.idFrascoSelecionado,
      this.state.idNovaTopografiaSelecionada,
      this.state.labelTopografiaAtual,
      this.state.labelNovaTopografiaSelecionada
    ).then((response) => {
      let tipoAlerta = response.success ? 'sucesso' : 'erro';
      let mensagemAlerta = response.success
        ? 'Topografia alterada com sucesso'
        : response.message;

      if (response.success) {
        let copiaFrascosGravados = [...this.props.frascosGravados];
        let frasco = copiaFrascosGravados.find(
          (el) => el.frascoId === this.state.idFrascoSelecionado
        );
        if (frasco !== null) {
          frasco.topografia = this.state.labelNovaTopografiaSelecionada;
          this.props.commonActions.adicionarFrasco(copiaFrascosGravados);
        }
      }

      this.toggleModalTopografia();
      this.props.commonActions.showFadeCarregando(false);
      this.props.commonActions.showAlerta(tipoAlerta, mensagemAlerta, 2000);
    });
  }

  cancelarFrasco() {
    if (this.state.justificativaCancelamentoFrasco === undefined) {
      this.props.commonActions.showAlerta(
        'alerta',
        'Informe uma justificativa para o cancelamento',
        2000,
        '450px'
      );
    } else {
      const {
        isUltimoFrasco,
        justificativaCancelamentoFrasco,
        cancelarBlocoAndLaminas,
        idFrascoSelecionado,
      } = this.state;

      const {
        detalhes,
        listagem,
        commonActions,
        actions,
        frascosGravados,
      } = this.props;

      this.props.commonActions.showFadeCarregando(true);

      if (isUltimoFrasco) {
        CommonFunctions.cancelarRecebimentoMaterial(
          detalhes,
          listagem,
          commonActions,
          justificativaCancelamentoFrasco,
          cancelarBlocoAndLaminas
        ).then((res) => {
          if (!res.data.cancelado && res.data.existeBlocoAndLamina) {
            commonActions.showFadeCarregando(false);
            this.setState({
              existeBlocoAndLamina: true,
              blocosExistentes: res.data.existeBlocoAndLamina.blocos,
              laminasExistentes: res.data.existeBlocoAndLamina.laminas,
            });
          } else {
            if (res.data.existeNConformidadePendente) {
              let tabNConformidade = '2';
              let larguraAlerta = res.data.mensagem.length * 10 + 'px';

              actions.mudarTabAtiva(tabNConformidade);
              commonActions.showAlerta(
                'erro',
                res.data.mensagem,
                3000,
                larguraAlerta
              );
            } else {
              WebapiCommon.obterStatusEtapasLaudo(detalhes.laudo).then(
                (etapas) => {
                  commonActions.atualizarStatusDasEtapasDoLaudo(
                    etapas,
                    detalhes.laudo
                  );
                  commonActions.atualizarNumeroExameDoLaudoNaListagem(
                    detalhes.laudo,
                    ''
                  );
                  CommonFunctions.fecharExameEtapaRecebimento(this.props);

                  this.toggleModalCancelFrasco(undefined);
                  commonActions.showFadeCarregando(false);
                  commonActions.showAlerta(
                    'sucesso',
                    'Recebimento cancelado com sucesso',
                    2000
                  );
                }
              );
            }
          }
        });
      } else {
        WebapiCommon.cancelarFrasco(
          detalhes.laudo,
          idFrascoSelecionado,
          justificativaCancelamentoFrasco
        ).then((response) => {
          let tipoAlerta = response.success ? 'sucesso' : 'erro';
          let mensagemAlerta = response.success
            ? 'Frasco cancelado com sucesso'
            : response.message;

          if (response.success) {
            let copiaFrascosGravados = [...frascosGravados];
            let frasco = copiaFrascosGravados.find(
              (el) => el.frascoId === idFrascoSelecionado
            );
            if (frasco !== null) {
              frasco.status = 'CANCELADO';
              commonActions.adicionarFrasco(copiaFrascosGravados);
            }
          }

          this.toggleModalCancelFrasco(undefined);
          commonActions.showFadeCarregando(false);
          commonActions.showAlerta(tipoAlerta, mensagemAlerta, 2000);
        });
      }
    }
  }

  onChangeJustificativaCancelamentoFrasco(texto) {
    this.setState({
      justificativaCancelamentoFrasco: texto,
    });
  }

  handleCreateSelectCreatable = (value) => {
    this.setState({
      showModalCadastroTopografia: true,
      topografiaASerCadastrada: value,
    });
  };

  toggleModalCadastroTopografia() {
    this.setState((state) => ({
      showModalCadastroTopografia: !state.showModalCadastroTopografia,
    }));
  }

  atualizarTopografias(topografias) {
    this.props.actions.atualizarTopografias(topografias);
  }

  selecionarTopografiaRecemCadastrada(topografia) {
    let topografiaPorNome = {
      ...this.props.topografias.find(
        (el) => this.removerCodigoLabelTopografia(el.label) === topografia
      ),
    };
    if (topografiaPorNome) {
      this.props.actions.alterarTopografiaSelecionada(topografiaPorNome);
    }
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    topografias: state.recebimentoMaterial.topografias,
    medicos: state.recebimentoMaterial.medicos,
    frascosGravados: state.commonReducer.frascosGravados,
    frascosNovos: state.commonReducer.frascosNovos,
    detalhes: state.commonReducer.detalhes,
    listagem: state.commonReducer.listagem,
    recebimentoFinalizado: state.recebimentoMaterial.recebimentoFinalizado,
    exameFinalizado: state.commonReducer.exameFinalizado,
    topografiaselecionada: state.recebimentoMaterial.topografiaselecionada,
    medicoMicroscopistaSelecionado: state.recebimentoMaterial.medicoMicroscopistaSelecionado,
    quantidadeFrascos: state.recebimentoMaterial.quantidadeFrascos,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceberContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/receber/receber.container.js